import { createContext, useContext } from "react";

export const OriginalDocumentDialogScopeContext = createContext(null);
const noAuxiliaryFocus = () => false;

export function useOriginalDocumentDialogScope() {
  return useContext(OriginalDocumentDialogScopeContext) || {
    portalTarget: document.body,
    allowsFocus: noAuxiliaryFocus,
    isSplit: false,
  };
}
